import { Injectable } from '@angular/core';
import { CsHttpClientService } from '@cbuild/cs-common-data-services';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs';
import { UserCompanyInfo } from '../models/user-company-info.model';
import { UserOrganization } from '../models/user-organization';
import { BaseUrlService } from '../services/base-url.service';
import { OrganizationConfiguration } from '../../sales/leads/lead-activity/create-customer/models/organization-configuration.model';
import { toQueryString } from '../../shared';

@Injectable()
export class NavMenuService {
  public $openedDropDown = new Subject();

  constructor(
    private http: CsHttpClientService,
    private baseUrlService: BaseUrlService
  ) {}

  public getUserCompanyInfo(): Observable<Array<UserCompanyInfo>> {
    return this.http.read<Array<UserCompanyInfo>>(
      'api/common/property/detail/get',
      this.baseUrlService.getApiBaseURL()
    );
  }

   public getConfigSettings(
      id: number
    ): Observable<OrganizationConfiguration> {
      return this.http
        .read<Array<OrganizationConfiguration>>(
          `api/settings/general-settings/get${toQueryString({
            id
          })}`
        )
        .pipe(map(_ => _[0]));
    }

  public selectedOrganizationGet(
    orgId: string | null
  ): Observable<UserOrganization> {
    return this.http
      .read<Array<UserOrganization>>(
        `api/account/user/organizations/get?orgId=${orgId}`,
        this.baseUrlService.getIdentityBaseURL()
      )
      .pipe(map(_ => _[0]));
  }
}
